import { environment } from "../../../environments/environment";
import { HelperService } from "../services/helper.service";

export class CommonBaseClass {
    helperService: HelperService
    isPWCEnabled = environment.isPWCEnabled;
    isMobile = window.innerWidth <= 824;

    constructor(helperService: HelperService){
        this.helperService = helperService;
    }

    navigateToMainProfile(): void {
        this.helperService.navigateToRoute('/reviewer/profile/main');
    }
}
  